import { AvatarMeta } from "./api";

export const DEFAULT_AVATAR_META: AvatarMeta = { x: 50, y: 50, zoom: 1 };

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

export const normalizeAvatarMeta = (meta?: AvatarMeta | null): AvatarMeta => {
  if (!meta) return DEFAULT_AVATAR_META;
  return {
    x: clamp(meta.x ?? DEFAULT_AVATAR_META.x!, 0, 100),
    y: clamp(meta.y ?? DEFAULT_AVATAR_META.y!, 0, 100),
    zoom: clamp(meta.zoom ?? DEFAULT_AVATAR_META.zoom!, 0.5, 3),
  };
};
